/**
 * External API key management via tenant-user-dashboard BFF.
 */

import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

export async function listExternalApiKeys(workspaceId) {
  return tenantApiFetch(
    tenantDashboardPath(`/workspaces/${encodeURIComponent(workspaceId)}/api-keys`),
  );
}

export async function createExternalApiKey(workspaceId, name) {
  return tenantApiFetch(
    tenantDashboardPath(`/workspaces/${encodeURIComponent(workspaceId)}/api-keys`),
    {
      method: "POST",
      body: JSON.stringify({ name }),
    },
  );
}

export async function revokeExternalApiKey(workspaceId, keyId) {
  return tenantApiFetch(
    tenantDashboardPath(`/workspaces/${encodeURIComponent(workspaceId)}/api-keys/${encodeURIComponent(keyId)}`),
    { method: "DELETE" },
  );
}
